import {DICT_ROLES} from './actions';
import {InitialState} from "./state";

export function reducer(state = InitialState, action) {
    if (action.type === DICT_ROLES) {
        return action.reduce(state);
    } else {
        return state;
    }
}